import difference from "lodash/difference";
import filter from "lodash/filter";
import forEach from "lodash/forEach";
import get from "lodash/get";
import includes from "lodash/includes";
import isNil from "lodash/isNil";
import map from "lodash/map";
import locale from "./buildRunMethodsError.locale";
export default (documentObjects, data) => {
    let invalidMessage = "";
    forEach(data, item => {
        if (invalidMessage)
            return false;
        forEach(item.nodesSource, source => {
            if (invalidMessage)
                return false;
            const documentObject = get(documentObjects, source.DocumentObjectId);
            if (!documentObject || !documentObject.Attributes)
                return true;
            const requiredMethodAttributes = get(documentObject.RequiredMethodAttributes, item.method.Id);
            if (!requiredMethodAttributes)
                return true;
            forEach(requiredMethodAttributes, attr => {
                if (invalidMessage)
                    return false;
                const filledRequiredAttributesKeys = map(filter(source.AttributeValues, sourceAttr => includes(attr.Item2, sourceAttr.Key) &&
                    !isNil(sourceAttr.Value) &&
                    sourceAttr.Value !== ""), "Key");
                if (attr.Item1 === "and" && filledRequiredAttributesKeys.length < attr.Item2.length) {
                    const emptyRequiredAttributesKeys = difference(attr.Item2, filledRequiredAttributesKeys);
                    const invalidMessageAttributeNames = map(filter(documentObject.Attributes, e => includes(emptyRequiredAttributesKeys, e.Key)), "Name");
                    invalidMessage = invalidMessageAttributeNames.length
                        ? locale.buildAndErrorMessage(documentObject.Name, invalidMessageAttributeNames)
                        : "";
                    return !invalidMessage;
                }
                if (attr.Item1 === "or" && filledRequiredAttributesKeys.length === 0) {
                    const invalidMessageAttributeNames = map(filter(documentObject.Attributes, e => includes(attr.Item2, e.Key)), "Name");
                    invalidMessage = invalidMessageAttributeNames.length
                        ? locale.buildOrErrorMessage(documentObject.Name, invalidMessageAttributeNames)
                        : "";
                    return !invalidMessage;
                }
                return true;
            });
            return true;
        });
        return true;
    });
    return invalidMessage;
};
